export const LOADING = 'Loading...'
